import { PageCountRequest, PageCountResponse } from '../../../../models/api/back/create-order/page-count';
import { AppThunk } from '../../../../app/store';
import { ordersDataActions } from '../../../../slices/orders/orders-data-slice';
import { ResponseBase } from '../../../response-base';
import { apiActions } from '../../../../slices/api-slice';
import { ApiBaseBack } from '../../api-base-back';
import { ordersActions } from '../../../../slices/orders-slice';

export class ApiPageCount extends ApiBaseBack<PageCountResponse> {
  constructor(param: PageCountRequest) {
    super(
      'GET',
      '/api/v1/pageCount',
      'JSON',
      param,
    );
  }
}

/* 商品切替直後の再発火などで旧選択のパラメータを積んだ応答が後着した場合は破棄する
   (現在の商品・デザインタイプ2選択と一致しない pageCount で上書きしないため) */
const isStaleResponse = (param: PageCountRequest, itemDetail: { itemSelect: { value: string }, designType2: { value: string } }) => (
  param.productNameId !== itemDetail.itemSelect.value
  || Boolean(param.dtemplId && param.dtemplId !== itemDetail.designType2.value)
);

// productFlg=2 のパターンも同タイミングで実施
export const apiPageCountThunk = (param: PageCountRequest, callback: () => void, isInit: boolean, agent: boolean): AppThunk => async (dispatch, getState) => {
  if ((param.productFlg === '1' && !param.productNameId) || (param.productFlg === '2' && !param.dtemplId)) {
    dispatch(ordersDataActions.updateOption({
      optionPageCount: null,
    }));
    /* デザインタイプ2未選択時は pageCount を空でワイプせず商品デフォルト値を再取得する
       (商品切替時に空ワイプが新商品の正常応答へ後着するとページ数変更不可になるため) */
    if (param.productFlg === '2' && param.productNameId) {
      dispatch(apiPageCountThunk(
        {
          productFlg: '1',
          productNameId: param.productNameId,
        },
        callback,
        isInit,
        agent,
      ));
      return;
    }
    dispatch(ordersDataActions.updateData({
      pageCount: {
        maxPageNum: '',
        minPageNum: '',
        stepPageNum: '',
      },
    }));
    callback?.();
    return;
  }
  dispatch(apiActions.run(
    new ApiPageCount(param),
    {
      onSuccess: (res: ResponseBase<PageCountResponse>) => {
        callback?.();
        if (!isInit && isStaleResponse(param, getState().order.itemDetail)) {
          return;
        }
        if (res.error.errorCode !== '404') {
          /* 応答データ欠落時は pageCount を undefined で上書きしない(直前の正常値を保持する) */
          if (res.body.data) {
            dispatch(ordersDataActions.updateData({
              pageCount: res.body.data,
            }));
          }
          const min = res.body.data?.minPageNum;
          const max = res.body.data?.maxPageNum;
          const step = res.body.data?.stepPageNum;
          const current = getState().order.genuine.page;
          if (!current || (min && max && (Number(min) > current || Number(max) < current)) || ((current - Number(min)) % Number(step || 1) !== 0)) {
            dispatch(ordersActions.genuine.setPage(Number(min), agent));
          }
        } else {
          dispatch(apiActions.run(
            new ApiPageCount({
              productFlg: '1',
              productNameId: param.productNameId!,
            }),
            {
              onSuccess: (res: ResponseBase<PageCountResponse>) => {
                /* 商品切替後に後着した応答や応答データ欠落時は上書きしない */
                if (!isInit && isStaleResponse(param, getState().order.itemDetail)) {
                  return;
                }
                if (!res.body.data) {
                  return;
                }
                dispatch(ordersDataActions.updateData({
                  pageCount: res.body.data,
                }));
                dispatch(ordersActions.genuine.setPage(Number(res.body.data.minPageNum), agent));
              },
            },
          ));
        }
        if (param.dtemplId) {
          dispatch(ordersDataActions.updateOption({
            optionPageCount: (res.body.data?.minPageNum || res.body.data?.maxPageNum || res.body.data?.stepPageNum) ? res.body.data : null,
          }));
        }
      },
      onError: () => {
        callback?.();
      },
    },
    {
      apiName: 'page-count',
      ignoreSystemError: true,
    },
  ));
};